export interface AgricultureNarrativeFacts {
  countyName: string;
  reportingYear: number;
  totalTco2e: number;
  largestCategory: string;
  largestSharePercent: number | null;
  changePercentSince2005: number | null;
}

export function buildAgricultureKeyInsights(f: AgricultureNarrativeFacts): string {
  const loc = f.countyName || 'the county';
  const share =
    f.largestSharePercent != null ? ` (${f.largestSharePercent.toFixed(1)}% of ${f.reportingYear} total)` : '';
  const trend =
    f.changePercentSince2005 != null
      ? ` Total agricultural GHG ${f.changePercentSince2005 >= 0 ? 'increased' : 'decreased'} by ${Math.abs(f.changePercentSince2005).toFixed(1)}% from 2005 to ${f.reportingYear}.`
      : '';
  return `Agricultural GHG emissions in ${loc} totaled ${Math.round(f.totalTco2e).toLocaleString()} metric tons CO₂e in ${f.reportingYear}. The largest category was ${f.largestCategory}${share}.${trend} Values come from the ClimatePlans ag_emissions county inventory table (CARB-aligned county categories), not USDA farm surveys or city boundary inventories.`;
}

export interface OffroadNarrativeFacts {
  locationName: string;
  reportingYear: number | null;
  totalTco2e: number | null;
  dominantCategory: string | null;
  changePercentSinceBaseline: number | null;
  baselineYear: number | null;
  allocationNote?: string;
}

export function buildOffroadKeyInsights(f: OffroadNarrativeFacts): string {
  if (f.totalTco2e == null || f.reportingYear == null) {
    return `Off-road GHG emissions are not available for ${f.locationName} in the displayed series.`;
  }
  const dom = f.dominantCategory ? ` ${f.dominantCategory} was the largest category.` : '';
  const trend =
    f.changePercentSinceBaseline != null && f.baselineYear != null
      ? ` Change from ${f.baselineYear} to ${f.reportingYear}: ${f.changePercentSinceBaseline >= 0 ? '+' : ''}${f.changePercentSinceBaseline.toFixed(1)}%.`
      : '';
  const alloc = f.allocationNote ? ` ${f.allocationNote}` : '';
  return `Off-road mobile-source GHG emissions in ${f.locationName} were ${Math.round(f.totalTco2e).toLocaleString()} metric tons CO₂e in ${f.reportingYear}.${dom}${trend}${alloc}`;
}
